<template>
  <div class="card-wrapper">
    <span style="padding: 0 0 3px 10px; display: inline-block">1. 选择模板:</span>
    <el-row style="padding: 10px" :gutter="10">
      <el-col
        :span="4"
        style="height: 295px; padding-bottom: 15px"
        v-for="item in modules"
        :key="item.id"
      >
        <el-card
          shadow="hover"
          :class="{ 'active-card': activeName === item.compName }"
          @click.native="selCard(item.compName)"
          :body-style="{ padding: '0px' }"
        >
          <el-image
            :lazy="true"
            style="width: 100%; height: 235px"
            :src="item.url"
            fit="contain"
            class="image"
          ></el-image>
          <div class="title-bar">
            <span>{{ item.name }}</span>
            <el-button @click="readFormat(item.format)" type="text" class="button">下载excel模板</el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Alert } from "element-ui";
import $pubsub from "../utils/pubsub.js";
export default {
  name: "cards",
  data() {
    return {
      activeName: null,
      modules: [],
    };
  },
  mounted() {
    const store = $pubsub();
    this.modules = store.getter("modules");
  },
  methods: {
    readFormat(src) {
      src && window.open(src);
    },
    selCard(name) {
      this.activeName = name;
      this.$emit("selType", name);
    },
    getCompType() {
      return this.activeName;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/cards.scss";
.card-wrapper {
  width: 100%;
  height: 52%;
  max-height: 323px;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-color: #00a4ff transparent;
  scrollbar-width: thin;

  .title-bar {
    padding: 0px 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .active-card {
    border: 1px solid #00a4ff;
    box-shadow: 0 2px 12px 0 rgb(0, 100, 250) !important;
  }
}
</style>
